// Status
export const SUCCESS = "success";
export const ERROR = "error";
export const PENDING = "pending";
